import React from 'react'
import { useParams } from 'react-router-dom'
import { useInitiative } from 'src/core/graphql/hooks'
import GNS3ResourceView from 'src/sites/custom/gns3/Resource/View'
import CustomPage from 'src/sites/kits/Object/apps/CustomPage'
import DynamicListPage from 'src/sites/kits/Object/apps/DynamicListPage' // eslint-disable-line import/no-cycle
import DynamicViewPage from 'src/sites/kits/Object/apps/DynamicViewPage'
import { LayoutContainer, LayoutContainerInner } from 'src/sites/kits/UI'

const pageComponents = {
   custom: CustomPage,
   dynamic: DynamicListPage,
   media: CustomPage
}

const ObjectView = () => {
   const { initiativeSlug } = useParams()
   const { initiative, networkStatus } = useInitiative({ slug: initiativeSlug })
   const initialLoading = networkStatus <= 2
   if (initialLoading) {
      return null
   }

   // Note: This is currently only for GNS3
   const isUrlOrFilesResource = initiative.class === 'resource' &&
      ['url', 'files'].includes(initiative.resourceFormat)

   if (isUrlOrFilesResource) {
      return <GNS3ResourceView />
   }

   if (initiative.class === 'page') {
      const Page = pageComponents[initiative.pageFormat]
      return <Page />
   }

   return (
      <LayoutContainer backgroundColor="#fff" maxWidth="750px[c] 1300px[e-f]">
         <LayoutContainerInner>
            <DynamicViewPage />
         </LayoutContainerInner>
      </LayoutContainer>
   )
}

export default ObjectView
